var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:email-send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0833 39.5833C27.0833 32.6875 32.6875 27.0833 39.5833 27.0833C41.875 27.0833 44 27.7083 45.8333 28.7708V12.5C45.8333 11.3949 45.3943 10.3351 44.6129 9.55372C43.8315 8.77231 42.7717 8.33333 41.6666 8.33333H8.33329C6.02079 8.33333 4.16663 10.1875 4.16663 12.5V37.5C4.16663 38.6051 4.60561 39.6649 5.38701 40.4463C6.16842 41.2277 7.22822 41.6667 8.33329 41.6667H27.2708C27.1666 40.9792 27.0833 40.2917 27.0833 39.5833ZM8.33329 16.6667V12.5L25 22.9167L41.6666 12.5V16.6667L25 27.0833L8.33329 16.6667ZM41.6666 45.8333V41.6667H33.3333V37.5H41.6666V33.3333L47.9166 39.5833L41.6666 45.8333Z",
    fill: "#F6931E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgSend);
export default __webpack_public_path__ + "static/media/msg-send.3f361125cbd2793ede2144aacde08a83.svg";
export { ForwardRef as ReactComponent };